<template>

  <header id="page-topbar">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->

        <div class="navbar-brand-box">
          <a class="logo logo-dark">
                            <span class="logo-sm">
                                    <img alt="" height="22" :src="'./assets/images/logo.svg'">
                                </span>

            <span class="logo-lg">
                                </span>
          </a>

          <a class="logo logo-light d-flex">
            <span class="logo-sm">
                <img alt="" height="50" :src="county_logo()">
            </span>
            <span class="logo-lg">
                <img alt="" height="45" :src="county_logo()">
            </span>


          </a>
        </div>

        <button onclick="toggleVerticalMenu()" id="vertical-menu-btn"
                class="btn btn-sm px-3 font-size-16 header-item waves-effect" type="button">
          <i class="fa fa-fw fa-bars"></i>
        </button>
        <!-- logo small -->
        <div class="phone-logo d-md-none d-sm-flex"><img alt="" class="img" :src="county_logo()"></div>



      </div>

      <div class="d-flex">
        <!-- small search -->
        <div class="dropdown d-inline-block d-lg-none ms-2">
          <button id="page-header-search-dropdown" aria-expanded="false" aria-haspopup="true"
                  class="btn header-item noti-icon waves-effect" data-bs-toggle="dropdown" type="button">
            <i class="mdi mdi-magnify"></i>
          </button>
          <div aria-labelledby="page-header-search-dropdown"
               class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">

            <form class="p-3">
              <div class="form-group m-0">
                <div class="input-group">
                  <input aria-label="Recipient's username" class="form-control" placeholder="Search ..." type="text">
                  <div class="input-group-append">
                    <button class="btn btn-primary" type="submit"><i class="mdi mdi-magnify"></i></button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="dropdown d-none d-lg-inline-block ms-1">
          <button class="btn header-item noti-icon waves-effect" data-bs-toggle="fullscreen" type="button">
            <i class="bx bx-fullscreen"></i>
          </button>
        </div>

        <div class="dropdown d-inline-block d-none">

          <!-- notifications, i will come to this later -->
          <button id="page-header-notifications-dropdown" aria-expanded="false" aria-haspopup="true"
                  class="btn header-item noti-icon waves-effect" data-bs-toggle="dropdown" type="button">
            <i class="bx bx-bell bx-tada"></i>
            <span class="badge bg-danger rounded-pill">3</span>
          </button>
          <div aria-labelledby="page-header-notifications-dropdown"
               class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
            <div class="p-3">
              <div class="row align-items-center">
                <div class="col">
                  <h6 key="t-notifications" class="m-0"> Notifications </h6>
                </div>
                <div class="col-auto">
                  <a key="t-view-all" class="small" href="#!"> View All</a>
                </div>
              </div>
            </div>
            <div data-simplebar style="max-height: 230px;">
              <a class="text-reset notification-item" href="javascript: void(0);">
                <div class="d-flex">
                  <div class="avatar-xs me-3">
                                            <span class="avatar-title bg-primary rounded-circle font-size-16">
                                                    <i class="bx bx-cart"></i>
                                                </span>
                  </div>
                  <div class="flex-grow-1">
                    <h6 key="t-your-order" class="mb-1">Your order is placed</h6>
                    <div class="font-size-12 text-muted">
                      <p key="t-grammer" class="mb-1">If several languages coalesce the grammar</p>
                      <p class="mb-0"><i class="mdi mdi-clock-outline"></i> <span key="t-min-ago">3 min ago</span></p>
                    </div>
                  </div>
                </div>
              </a>
              <a class="text-reset notification-item" href="javascript: void(0);">
                <div class="d-flex">
                  <img alt="user-pic" class="me-3 rounded-circle avatar-xs" :src="'./assets/images/users/avatar-3.jpg'">
                  <div class="flex-grow-1">
                    <h6 class="mb-1">James Lemire</h6>
                    <div class="font-size-12 text-muted">
                      <p key="t-simplified" class="mb-1">It will seem like simplified English.</p>
                      <p class="mb-0"><i class="mdi mdi-clock-outline"></i> <span key="t-hours-ago">1 hours ago</span>
                      </p>
                    </div>
                  </div>
                </div>
              </a>

              <a class="text-reset notification-item" href="javascript: void(0);">
                <div class="d-flex">
                  <div class="avatar-xs me-3">
                                            <span class="avatar-title bg-success rounded-circle font-size-16">
                                                    <i class="bx bx-badge-check"></i>
                                                </span>
                  </div>
                  <div class="flex-grow-1">
                    <h6 key="t-shipped" class="mb-1">Your item is shipped</h6>
                    <div class="font-size-12 text-muted">
                      <p key="t-grammer" class="mb-1">If several languages coalesce the grammar</p>
                      <p class="mb-0"><i class="mdi mdi-clock-outline"></i> <span key="t-min-ago">3 min ago</span></p>
                    </div>
                  </div>
                </div>
              </a>

              <a class="text-reset notification-item" href="javascript: void(0);">
                <div class="d-flex">
                  <img alt="user-pic" class="me-3 rounded-circle avatar-xs" :src="'./assets/images/users/avatar-4.jpg'">
                  <div class="flex-grow-1">
                    <h6 class="mb-1">Salena Layfield</h6>
                    <div class="font-size-12 text-muted">
                      <p key="t-occidental" class="mb-1">As a skeptical Cambridge friend of mine occidental.</p>
                      <p class="mb-0"><i class="mdi mdi-clock-outline"></i> <span key="t-hours-ago">1 hours ago</span>
                      </p>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div class="p-2 border-top d-grid">
              <a class="btn btn-sm btn-link font-size-14 text-center" href="javascript:void(0)">
                <i class="mdi mdi-arrow-right-circle me-1"></i> <span key="t-view-more">View More..</span>
              </a>
            </div>
          </div>
        </div>


        <div class="dropdown d-inline-block">

          <div class="dropdown d-inline-block">
            <button type="button" class="btn header-item waves-effect" id="page-header-user-dropdown"
                    data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <img class="rounded-circle header-profile-user" :src="county_logo()"
                   alt="Header Avatar">
              <span class="d-none d-xl-inline-block ms-1" key="t-henry">{{ sessionNames }}</span>
              <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-end">
              <a @click="changePassword()" class="dropdown-item" href="javascript: void(0);"><i
                  class="bx bx-lock-open font-size-16 align-middle me-1"></i> <span
                  key="t-lock-screen">Change Password</span></a>
              <div class="dropdown-divider"></div>

              <a @click="logout('/')" class="dropdown-item text-danger" href="javascript: void(0);"><i
                  class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i> <span
                  key="t-logout">Logout</span></a>
            </div>


          </div>


        </div>
      </div>
    </div>
  </header>

  <div id="vertical-menu" class="vertical-menu">

    <div class="h-100" data-simplebar>

      <!--- Sidemenu -->
      <div id="sidebar-menu">
        <!-- Left Menu Start -->
        <ul id="side-menu" class="metismenu list-unstyled text-capitalize">
          <li key="t-pages" class="menu-title d-none">Best Birdy Billing system.</li>

          <li v-if="getRight('BILLS')" class="side-bar-button">
            <a @click="gotToSelected('new-bill')"
               class="waves-effect btn btn-light btn-rounded text-left write-msg-btn">
              <i class=""><img alt="" src="assets/images/plus-icon.svg"></i>
              <span class="text-capitalize">Create Invoice</span>
            </a>
          </li>

          <li v-if="getRight('REVENUE DASHBOARD')" :class="{ 'mm-active': selected === 'dashboard' }">
            <a @click="gotToSelected('dashboard')" class="waves-effect">
              <i class="bx bx-home-circle"></i><span>Home</span>
            </a>
          </li>

          <!-- AI Assistant Menu Item -->
          <li v-if="getRight('AI ASSISTANT')" :class="{ 'mm-active': selected === 'ai-assistant' }">
            <a @click="gotToSelected('ai-assistant')" class="waves-effect">
              <i class="bx bx-bot"></i>
              <span>AI Assistant</span>
            </a>
          </li>

          <li v-if="getRight('REVENUE CENTER') || getRight('REPORTS')">
            <a href="javascript: void(0);" @click="gotToSelected('markets_dashboard')" class="waves-effect">
              <i class="mdi mdi-store"></i><span>Revenue Center</span>
            </a>
          </li>

          <li v-if="getRight('LIVE MONITORING')">
            <a href="javascript: void(0);" @click="gotToSelected('live_monitoring')" class="waves-effect">
              <i class="bx bx-user-voice"></i><span>Performance</span>
            </a>
          </li>

          <li v-if="getRight('E WALLET SYSTEM')">
            <a href="javascript: void(0);" @click="gotToSelected('e-wallet-system')" class="waves-effect">
              <i class="bx bx-user-voice"></i><span>E Wallet System</span>
            </a>
          </li>

          <li v-if="getRight('TAXPAYER DATABASE')">
            <a href="javascript: void(0);" @click="gotToSelected('taxpayer-database')" class="waves-effect">
              <i class="bx bx-user-voice"></i><span>Taxpayer Database</span>
            </a>
          </li>

          <li v-if="getRight('PROPERTY MANAGEMENT')">
            <a href="javascript: void(0);" @click="gotToSelected('property-management')" class="waves-effect">
              <i class="bx bx-user-voice"></i><span>Property Management</span>
            </a>
          </li>

          <li v-if="getRight('OUTDOOR ADVERTISING')">
            <a href="javascript: void(0);" @click="gotToSelected('outdoor-advertising')" class="waves-effect">
              <i class="bx bx-paper-plane"></i><span>Outdoor Advertising</span>
            </a>
          </li>

          <li v-if="getRight('PARK MANAGEMENT')">
            <a href="javascript: void(0);" @click="gotToSelected('park-system')" class="waves-effect">
              <i class="bx bxs-tree"></i><span>Park Management</span>
            </a>
          </li>

          <li v-if="getRight('NETWORK COVERAGE')" :class="{ 'mm-active': selected === 'internet-mapping' }">
            <a @click="gotToSelected('internet-mapping')" class="waves-effect">
              <i class="mdi mdi-wifi-marker"></i>
              <span>Network Coverage</span>
            </a>
          </li>

          <li v-if="getRight('PARKING')" :class="{ 'mm-active': selected === 'parking' }">
            <a @click="selectedMenu('parking')" class="waves-effect has-arrow">
              <i class="mdi mdi-car-back"></i>
              <span>Parking</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'parking' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('PARKING')" :class="{ 'mm-active': selectedSub === 'parking_dashboard' }"><a
                  href="javascript: void(0);" @click="gotTo('parking_dashboard')">Overview</a></li>
              <li v-if="getRight('SEASONAL PARKING')" :class="{ 'mm-active': selectedSub === 'parking-fleet' }"><a
                  href="javascript: void(0);" @click="gotTo('parking-fleet')">Seasonal</a></li>
              <li v-if="getRight('PARKING')" :class="{ 'mm-active': selectedSub === 'daily_parking' }"><a
                  href="javascript: void(0);" @click="gotTo('daily_parking')">Daily</a></li>
              <li v-if="getRight('PARKING')" :class="{ 'mm-active': selectedSub === 'monthly_parking' }"><a
                  href="javascript: void(0);" @click="gotTo('monthly_parking')">Monthly</a></li>
              <li v-if="getRight('PARKING')" :class="{ 'mm-active': selectedSub === 'weekly_parking' }"><a
                  href="javascript: void(0);" @click="gotTo('weekly_parking')">Weekly</a></li>
              <li v-if="getRight('PARKING')" :class="{ 'mm-active': selectedSub === 'vehicles_register' }"><a
                  href="javascript: void(0);" @click="gotTo('vehicles_register')">Vehicles Register</a></li>
              <li v-if="getRight('PARKING')" :class="{ 'mm-active': selectedSub === 'clamped_vehicles' }"><a
                  href="javascript: void(0);" @click="gotTo('clamped_vehicles')">Vehicles Clamped</a></li>
            </ul>
          </li>

          <li v-if="getRight('FINANCE ACT')" :class="{ 'mm-active': selected === 'finance-act' }">
            <a class="waves-effect" @click="gotToSelected('finance-act')">
              <i class="mdi mdi-currency-usd"></i><span>Finance Bill</span>
            </a>
          </li>

          <li v-if="getRight('BILLS')" :class="{ 'mm-active': selected === 'bills' }">
            <a @click="selectedMenu('bills')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="bx bx-receipt"></i>
              <span>Invoices</span>
            </a>
            <ul v-if="getRight('BILLS')" :class="{ 'mm-active': selected === 'bills' }" class="sub-menu">
              <li v-if="getRight('CREATE BILL')" :class="{ 'mm-active': selectedSub === 'new-bill' }">
                <a href="javascript: void(0);" @click="gotTo('new-bill')">Create Invoice</a>
              </li>
              <li v-if="getRight('UNPAID BILLS')" :class="{ 'mm-active': selectedSub === 'bulk-bill-upload' }">
                <a href="javascript: void(0);" @click="gotTo('bulk-bill-upload')">Bulk Upload</a>
              </li>
              <li class="menu-divider"></li>
              <li v-if="getRight('BILLS RAISED')" :class="{ 'mm-active': selectedSub === 'bills-raised' }">
                <a href="javascript: void(0);" @click="gotTo('bills-raised')">Invoices raised</a>
              </li>
              <li v-if="getRight('RECEIPTED BILLS')" :class="{ 'mm-active': selectedSub === 'bills-receipted' }">
                <a href="javascript: void(0);" @click="gotTo('bills-receipted')">Paid Invoices</a>
              </li>
              <li v-if="getRight('UNPAID BILLS')" :class="{ 'mm-active': selectedSub === 'un-paid-bills' }">
                <a href="javascript: void(0);" @click="gotTo('un-paid-bills')">Unpaid Invoices</a>
              </li>
              <li v-if="getRight('WAIVED BILLS')" :class="{ 'mm-active': selectedSub === 'waived-bills' }">
                <a href="javascript: void(0);" @click="gotTo('waived-bills')">Waived Bills</a>
              </li>
              <li v-if="getRight('INVOICE WITH NO COLLECTORS')" :class="{ 'mm-active': selectedSub === 'un-paid-bills' }">
                <a href="javascript: void(0);" @click="gotTo('invoices-no-collectors')">Invoices With No Collectors</a>
              </li>
              <li v-if="getRight('DISPUTE RESOLUTION')" :class="{ 'mm-active': selectedSub === 'dispute-resolution' }">
                <a href="javascript:void(0);" @click="gotTo('dispute-resolution')">Dispute Resolution</a>
              </li>
              <li v-if="getRight('ORPHANED BILLS')" :class="{ 'mm-active': selectedSub === 'orphanes' }">
                <a href="javascript:void(0);" @click="gotTo('orphanes')">Orphaned</a>
              </li>
              <li v-if="getRight('DUPLICATE INVOICE MANAGEMENT')" :class="{ 'mm-active': selectedSub === 'duplicate-invoice-management' }">
                <a href="javascript:void(0);" @click="gotTo('duplicate-invoice-management')">Duplicate Management</a>
              </li>
              <li v-if="getRight('DUPLICATE INVOICE MANAGEMENT')" :class="{ 'mm-active': selectedSub === 'duplicate-bill-no-management' }">
                <a href="javascript:void(0);" @click="gotTo('duplicate-bill-no-management')">Duplicate Bill Numbers</a>
              </li>
            </ul>
          </li>

          <li v-if="getRight('PAYMENT AND RECEIPTING')" :class="{ 'mm-active': selected === 'Payments & Receipting' }">
            <a @click="selectedMenu('Payments & Receipting')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="mdi mdi-receipt"></i>
              <span>Payments</span>
            </a>
            <ul aria-expanded="false" class="sub-menu" :class="{ 'mm-active': selected === 'Payments & Receipting' }">
              <li v-if="getRight('BULK RECEIPTS')" :class="{ 'mm-active': selectedSub === 'bulk-receipts' }">
                <a style="cursor: pointer;" @click="gotTo('bulk-receipts')">Receive Payments</a>
              </li>
              <li v-if="getRight('VIEW RECEIPTS')" :class="{ 'mm-active': selectedSub === 'receipts' }">
                <a style="cursor: pointer;" @click="gotTo('receipts')">View Receipts</a>
              </li>
            </ul>
          </li>

          <li v-if="getRight('RECON')" :class="{ 'mm-active': selected === 'recons' }">
            <a @click="selectedMenu('recons')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="bx bx-calendar-check"></i>
              <span>Recons</span>
            </a>
            <ul aria-expanded="false" class="sub-menu" :class="{ 'mm-active': selected === 'recons' }">
              <li v-if="getRight('AUTO RECONCILIATION')" :class="{ 'mm-active': selectedSub === 'recon' }">
                <a style="cursor: pointer;" @click="gotTo('recon')">
                  <i class="bx bx-check-circle me-1"></i>Auto Reconciliation
                </a>
              </li>
              <li v-if="getRight('BANK RECONCILIATION')" :class="{ 'mm-active': selectedSub === 'bank-reconciliation' }">
                <a style="cursor: pointer;" @click="gotTo('bank-reconciliation')">
                  <i class="bx bx-sync me-1"></i>Bank Reconciliation
                </a>
              </li>
              <li v-if="getRight('HISTORICAL RECONCILIATION')" :class="{ 'mm-active': selectedSub === 'recon-all' }">
                <a style="cursor: pointer;" @click="gotTo('recon-all')">
                  <i class="bx bx-list-check me-1"></i>Historical
                </a>
              </li>
            </ul>
          </li>

          <li v-if="getRight('ACTION CENTER PAGE')" :class="{ 'mm-active': selected === 'action-center' }">
            <a @click="selectedMenu('action-center')" class="waves-effect has-arrow">
              <i class="mdi mdi-flag"></i>
              <span>Action Center</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'action-center' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('REQUEST PAYMENT CORRECTION PAGE')" :class="{ 'mm-active': selectedSub === 'flagged-transaction-correction' }">
                <a href="javascript: void(0);" @click="gotTo('flagged-transaction-correction')">Request Correction</a>
              </li>
              <li v-if="getRight('APPROVE PAYMENT CORRECTION PAGE')" :class="{ 'mm-active': selectedSub === 'transaction-correction-request' }">
                <a href="javascript: void(0);" @click="gotTo('transaction-correction-request')">Approve Correction</a>
              </li>
            </ul>
          </li>

          <li v-if="getRight('WAIVER')">
            <a href="javascript: void(0);" @click="gotToSelected('waiver-pending')" class="waves-effect">
              <i class="bx bx-check-shield"></i><span>Waiver</span>
            </a>
          </li>

          <li v-if="getRight('PWD')">
            <a href="javascript: void(0);" @click="gotToSelected('pwd-pending')" class="waves-effect">
              <i class="bx bx-check-shield"></i><span>PWD</span>
            </a>
          </li>

          <li class="d-none">
            <a href="javascript: void(0);" @click="gotToSelected('customer-management')" class="waves-effect">
              <i class="bx bx-group"></i><span>Customers Management</span>
            </a>
          </li>

          <li v-if="getRight('E-CONSTRUCTION')" :class="{ 'mm-active': selected === 'e-Construction' }">
            <a @click="selectedMenu('e-Construction')" class="waves-effect has-arrow">
              <i class="mdi mdi-office-building"></i>
              <span>E-Construction</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'e-Construction' }" class="sub-menu" aria-expanded="false">
              <!-- NEW: Plans Dashboard -->
              <li v-if="getRight('E-CONSTRUCTION DASHBOARD')" :class="{ 'mm-active': selectedSub === 'plans-dashboard' }">
                <a href="javascript: void(0);" @click="gotTo('plans-dashboard')">
                  <i class="mdi mdi-chart-line me-1"></i>
                  <span class="badge bg-primary text-white float-end" style="font-size: 10px;">New</span>
                  Dashboard
                </a>
              </li>

              <li class="d-none" v-if="getRight('E-CONSTRUCTION STATS')" :class="{ 'mm-active': selectedSub === 'e-construction-stats' }">
                <a href="javascript: void(0);" @click="gotTo('e-construction-stats')">Stats</a>
              </li>
              <li v-if="getRight('E-CONSTRUCTION NEW APPLICATION')" :class="{ 'mm-active': selectedSub === 'e-construction-application' }">
                <a href="javascript: void(0);" @click="gotTo('e-construction-application')">New App</a>
              </li>
              <li v-if="getRight('E-CONSTRUCTION IN PROGRESS')" :class="{ 'mm-active': selectedSub === 'e-construction-progress' }">
                <a href="javascript: void(0);" @click="gotTo('e-construction-progress')">In Progress</a>
              </li>
              <li v-if="getRight('E-CONSTRUCTION APPROVED')" :class="{ 'mm-active': selectedSub === 'e-construction-approved' }">
                <a href="javascript: void(0);" @click="gotTo('e-construction-approved')">Approved</a>
              </li>
              <li v-if="getRight('E-CONSTRUCTION BILL APPROVALS')" :class="{ 'mm-active': selectedSub === 'bill-approvals' }">
                <a href="javascript: void(0);" @click="gotTo('bill-approvals')">
                  <span class="badge bg-warning text-dark float-end" style="font-size: 10px;">Pending</span>
                  Bill Approvals
                </a>
              </li>
              <li v-if="getRight('E-CONSTRUCTION APPROVED BILLS')" :class="{ 'mm-active': selectedSub === 'approved-bills' }">
                <a href="javascript: void(0);" @click="gotTo('approved-bills')">
                  <span class="badge bg-success text-white float-end" style="font-size: 10px;">History</span>
                  Approved Bills
                </a>
              </li>
              <li class="d-none" v-if="getRight('E-CONSTRUCTION REJECTED')" :class="{ 'mm-active': selectedSub === 'e-construction-rejected' }">
                <a href="javascript: void(0);" @click="gotTo('e-construction-rejected')">Rejected</a>
              </li>
              <li class="d-none" v-if="getRight('E-CONSTRUCTION PROFESSIONAL')" :class="{ 'mm-active': selectedSub === 'e-construction-professional' }">
                <a href="javascript: void(0);" @click="gotTo('e-construction-professional')">Pros</a>
              </li>
              <li class="d-none" v-if="getRight('E-CONSTRUCTION NEW PROFESSIONAL')" :class="{ 'mm-active': selectedSub === 'e-construction-new-professional' }">
                <a href="javascript: void(0);" @click="gotTo('e-construction-new-professional')">New Pros</a>
              </li>
              <li class="d-none" v-if="getRight('E-CONSTRUCTION REJECTED PROFESSIONAL')" :class="{ 'mm-active': selectedSub === 'e-construction-rejected-professional' }">
                <a href="javascript: void(0);" @click="gotTo('e-construction-rejected-professional')">Rejected Pros</a>
              </li>
            </ul>
          </li>


          <li v-if="getRight('RATES')" :class="{ 'mm-active': selected === 'landPlot' }">
            <a @click="selectedMenu('landPlot')" class="waves-effect has-arrow">
              <i class="mdi mdi-map-clock-outline"></i>
              <span>Rates(Land & Plot)</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'landPlot' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('PLOT RENT')" :class="{ 'mm-active': selectedSub === 'plot_rent' }">
                <a href="javascript: void(0);" @click="gotTo('plot_rent')">Plot Rent</a>
              </li>
              <li v-if="getRight('LAND RATE')" :class="{ 'mm-active': selectedSub === 'land-rate' }">
                <a href="javascript: void(0);" @click="gotTo('land-rate')">Land Rates</a>
              </li>
              <li v-if="getRight('LAND RATE')" :class="{ 'mm-active': selectedSub === 'clearance-dashboard' }">
                <a href="javascript: void(0);" @click="gotTo('clearance-dashboard')">Clearence Certifcate</a>
              </li>
              <li v-if="getRight('LAND RATE PENDING TRANSFER')" :class="{ 'mm-active': selectedSub === 'pending-transfer' }">
                <a href="javascript: void(0);" @click="gotTo('pending-transfer')">Pending Transfer</a>
              </li>
              <li v-if="getRight('LAND RATE APPROVED TRANSFER')" :class="{ 'mm-active': selectedSub === 'approved-transfer' }">
                <a href="javascript: void(0);" @click="gotTo('approved-transfer')">Approved Transfer</a>
              </li>
              <li v-if="getRight('LAND RATE DECLINED TRANSFER')" :class="{ 'mm-active': selectedSub === 'decline-transfer' }">
                <a href="javascript: void(0);" @click="gotTo('decline-transfer')">Declined Transfer</a>
              </li>
              <li v-if="getRight('LAND RATE RE-SUBMIT TRANSFER')" :class="{ 'mm-active': selectedSub === 're-approve-transfer' }">
                <a href="javascript: void(0);" @click="gotTo('re-approve-transfer')">Re-Submitted Transfers</a>
              </li>
            </ul>
          </li>

          <li v-if="getRight('VALUATION ROLL')" :class="{ 'mm-active': selected === 'valuation-dashboard' }">
            <a @click="gotToSelected('valuation-dashboard')" class="waves-effect">
              <i class="mdi mdi-home-analytics"></i>
              <span>Valuation Roll</span>
            </a>
          </li>

          <li v-if="getRight('HOUSING')" :class="{ 'mm-active': selected === 'housing' }">
            <a @click="selectedMenu('housing')" class="waves-effect has-arrow">
              <i class="mdi mdi-map-marker-radius"></i>
              <span>Housing</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'housing' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('HOUSING REGISTER')" :class="{ 'mm-active': selectedSub === 'housing-register' }">
                <a href="javascript: void(0);" @click="gotTo('housing-register')">Rentals Register</a>
              </li>
            </ul>
          </li>

          <li v-if="getRight('CERTIFICATE AND LICENCING')" :class="{ 'mm-active': selected === 'trade' }">
            <a @click="selectedMenu('trade')" style="cursor: pointer;" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="mdi-certificate mdi"></i>
              <span>Licencing</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'trade' }" aria-expanded="false" class="sub-menu">
              <li v-if="getRight('BUSINESS PERMITS')" :class="{ 'mm-active': selectedSub === 'cert-biz-stats' }">
                <a href="javascript: void(0);" @click="gotTo('cert-biz-stats')">SBP Licencing</a>
              </li>
              <li v-if="getRight('FIRE LICENCE') || getRight('FIRE LICENSE')" :class="{ 'mm-active': selectedSub === 'fire-dashboard' }">
                <a href="javascript: void(0);" @click="gotTo('fire-dashboard')">Fire Licencing</a>
              </li>
              <li v-if="getRight('LIQUOR LICENCE')" :class="{ 'mm-active': selectedSub === 'cert-alcohol-dashboard' }">
                <a href="javascript: void(0);" @click="gotTo('cert-alcohol-dashboard')">Liquor Licencing</a>
              </li>
              <li v-if="getRight('FOOD HYGIENE')" :class="{ 'mm-active': selectedSub === 'hygiene-dashboard' }">
                <a href="javascript: void(0);" @click="gotTo('hygiene-dashboard')">Hygiene Certificate</a>
              </li>
              <li v-if="getRight('MEDICAL CERTIFICATE')" :class="{ 'mm-active': selectedSub === 'medical-dashboard' }">
                <a href="javascript: void(0);" @click="gotTo('medical-dashboard')">Medical Certificate</a>
              </li>
            </ul>
          </li>

          <li v-if="getRight('BUSINESSES MAPPING')" :class="{ 'mm-active': selected === 'mapping' }">
            <a @click="selectedMenu('mapping')" class="waves-effect has-arrow">
              <i class="mdi mdi-map-marker-radius"></i>
              <span>Trade mapping</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'mapping' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('LIVE MAP')" :class="{ 'mm-active': selectedSub === 'business-mapping' }">
                <a href="javascript: void(0);" @click="gotTo('business-mapping')">Geo location</a>
              </li>
              <li v-if="getRight('BUSINESS REGISTER')" :class="{ 'mm-active': selectedSub === 'business-data' }">
                <a href="javascript: void(0);" @click="gotTo('business-data')">SBP list</a>
              </li>
            </ul>
          </li>

          <li v-if="getRight('REPORTS')" :class="{ 'mm-active': selected === 'reports' }">
            <a @click="selectedMenu('reports')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="bx bx-file"></i>
              <span>Reports</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'reports' }" style="cursor: pointer;" aria-expanded="false" class="sub-menu text-capitalize">
              <li v-if="getRight('REVENUE STREAMS COLLECTIONS')" :class="{ 'mm-active': selectedSub === 'reports-streams' }" style="cursor: pointer;" class="text-capitalize">
                <a @click="gotTo('reports-streams')">By Streams</a>
              </li>
              <li v-if="getRight('COLLECTIONS BY SUB COUNTIES')" :class="{ 'mm-active': selectedSub === 'reports-sub-county' }" style="cursor: pointer;" class="text-capitalize">
                <a @click="gotTo('reports-sub-county')">By Sub Counties</a>
              </li>
              <li v-if="getRight('COLLECTIONS BY DEPARTMENT')" :class="{ 'mm-active': selectedSub === 'department-performance' }" style="cursor: pointer;" class="text-capitalize">
                <a @click="gotTo('department-performance')">By Department</a>
              </li>
              <li v-if="getRight('COLLECTION SOURCES REPORT')" :class="{ 'mm-active': selectedSub === 'reports-sources' }" style="cursor: pointer;" class="text-capitalize">
                <a @click="gotTo('reports-sources')">Collection Sources</a>
              </li>
              <li v-if="getRight('ALL TRANSACTIONS')" :class="{ 'mm-active': selectedSub === 'transactions' }" style="cursor: pointer;" class="text-capitalize">
                <a @click="gotTo('transactions')">All Payments</a>
              </li>
              <li v-if="getRight('ALL TRANSACTIONS')" :class="{ 'mm-active': selectedSub === 'transactions-codes-search' }" style="cursor: pointer;" class="text-capitalize">
                <a @click="gotTo('transactions-codes-search')">Transaction Lookup</a>
              </li>
              <li v-if="getRight('UNPAID INVOICES REPORT')" :class="{ 'mm-active': selectedSub === 'reports-streams-unpaid' }" style="cursor: pointer;" class="text-capitalize">
                <a @click="gotTo('reports-streams-unpaid')">Unpaid Invoices</a>
              </li>
              <li v-if="getRight('PAID INVOICES REPORT')" :class="{ 'mm-active': selectedSub === 'reports-streams-paid' }" style="cursor: pointer;" class="text-capitalize">
                <a @click="gotTo('reports-streams-paid')">Paid Invoices</a>
              </li>
              <li v-if="getRight('RANKINGS REPORT')" :class="{ 'mm-active': selectedSub === 'ranking' }" style="cursor: pointer;" class="text-capitalize">
                <a @click="gotTo('ranking')">Rankings</a>
              </li>
            </ul>
          </li>

          <li v-if="getRight('COLLECTION ZONES')" :class="{ 'mm-active': selected === 'zones' }" style="cursor: pointer;">
            <a @click="gotToSelected('zones')" class="waves-effect">
              <i class="mdi mdi-map"></i><span>Revenue Zones</span>
            </a>
          </li>

          <li v-if="getRight('SYSTEM USERS')" :class="{ 'mm-active': selected === 'users' }">
            <a @click="selectedMenu('users')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="mdi mdi-monitor-multiple"></i>
              <span>User Management</span>
            </a>
            <ul v-if="getRight('SYSTEM USERS')" :class="{ 'mm-active': selected === 'users' }" aria-expanded="false" class="sub-menu">
              <li v-if="getRight('USER ACCOUNT')" :class="{ 'mm-active': selectedSub === 'set-accounts' }">
                <a style="cursor: pointer;" @click="gotTo('set-accounts')">Roles</a>
              </li>
              <li v-if="getRight('SYSTEM USERS')" :class="{ 'mm-active': selectedSub === 'users' }">
                <a style="cursor: pointer;" @click="gotTo('users')">Users</a>
              </li>
              <li v-if="getRight('AUDIT LOGS')" :class="{ 'mm-active': selectedSub === 'all-user-logs' }">
                <a style="cursor: pointer;" @click="gotTo('all-user-logs')">Audit Logs</a>
              </li>
              <li v-if="getRight('ADD SYSTEM USER')" :class="{ 'mm-active': selectedSub === 'add-users' }">
                <a style="cursor: pointer;" @click="gotTo('add-users')">Register user</a>
              </li>
            </ul>
          </li>

          <li v-if="getRight('SETTINGS AND SETUPS')" :class="{ 'mm-active': selected === 'settings' }">
            <a @click="selectedMenu('settings')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="bx bx-slider"></i>
              <span>Configurations</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'settings' }" aria-expanded="false" class="sub-menu">
              <li v-if="getRight('DEPARTMENT')" :class="{ 'mm-active': selectedSub === 'department' }">
                <a style="cursor: pointer;" @click="gotTo('department')">For Department</a>
              </li>
              <li v-if="getRight('REVENUE STREAM')" :class="{ 'mm-active': selectedSub === 'revenue-stream' }">
                <a style="cursor: pointer;" @click="gotTo('revenue-stream')"> For Revenue Stream</a>
              </li>
              <li v-if="getRight('REVENUE TARGET')" :class="{ 'mm-active': selectedSub === 'targets-SubCounty' }">
                <a style="cursor: pointer;" @click="gotTo('targets-SubCounty')">For Revenue Targets</a>
              </li>
              <li v-if="getRight('SYSTEM INTEGRATIONS')" :class="{ 'mm-active': selectedSub === 'system-integrations' }">
                <a href="javascript: void(0);" @click="gotTo('system-integrations')">System Integrations</a>
              </li>
              <li v-if="getRight('SECURITY DASHBOARD')" :class="{ 'mm-active': selectedSub === 'security-dashboard' }">
                <a href="javascript: void(0);" @click="gotTo('security-dashboard')">Security Dashboard</a>
              </li>
              <li v-if="getRight('PAYMENT CONFIGURATIONS')" :class="{ 'mm-active': selectedSub === 'payment-configurations' }">
                <a href="javascript: void(0);" @click="gotTo('payment-configurations')">Payment Configurations</a>
              </li>
            </ul>
          </li>


          <!-- =====================================================
                   COUNTY HOSPITAL SECTION - HEALTH SERVICES
                   ===================================================== -->

          <li class="menu-title" v-if="getRight('HOSPITAL')">Health Services</li>

          <!-- Hospital Facility Selector -->
          <!-- Hospital Dashboard -->
          <li v-if="getRight('HOSPITAL DASHBOARD')" :class="{ 'mm-active': selectedSub === 'hospital-dashboard' }">
            <a @click="gotTo('hospital-dashboard')" class="waves-effect">
              <i class="bx bx-plus-medical"></i><span>Hospital Dashboard</span>
            </a>
          </li>

          <!-- Facilities Management -->
          <li v-if="getRight('FACILITIES MANAGEMENT')" :class="{ 'mm-active': selectedSub === 'facilities' }">
            <a @click="gotTo('facilities')" class="waves-effect">
              <i class="bx bx-building-house"></i><span>Facilities</span>
            </a>
          </li>

          <!-- Patients -->
          <li v-if="getRight('PATIENTS')" :class="{ 'mm-active': selected === 'patients' }">
            <a @click="selectedMenu('patients')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="bx bx-user-plus"></i>
              <span>Patients</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'patients' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('PATIENT REGISTRATION')" :class="{ 'mm-active': selectedSub === 'patient-register' }">
                <a href="javascript: void(0);" @click="gotTo('patient-register')">Register Patient</a>
              </li>
              <li v-if="getRight('PATIENT SEARCH')" :class="{ 'mm-active': selectedSub === 'patient-search' }">
                <a href="javascript: void(0);" @click="gotTo('patient-search')">Search Patient</a>
              </li>
              <li v-if="getRight('PATIENT LIST')" :class="{ 'mm-active': selectedSub === 'patient-list' }">
                <a href="javascript: void(0);" @click="gotTo('patient-list')">All Patients</a>
              </li>

            </ul>
          </li>

          <!-- Reception -->
          <li v-if="getRight('RECEPTION')" :class="{ 'mm-active': selected === 'reception' }">
            <a @click="selectedMenu('reception')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="bx bx-door-open"></i>
              <span>Reception</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'reception' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('NEW VISIT')" :class="{ 'mm-active': selectedSub === 'new-visit' }">
                <a href="javascript: void(0);" @click="gotTo('new-visit')">New Visit</a>
              </li>
              <li v-if="getRight('QUEUE MANAGEMENT')" :class="{ 'mm-active': selectedSub === 'queue-management' }">
                <a href="javascript: void(0);" @click="gotTo('queue-management')">Queue Management</a>
              </li>
            </ul>
          </li>

          <!-- Billing / Cashier -->
          <li v-if="getRight('BILLING')" :class="{ 'mm-active': selected === 'billing' }">
            <a @click="selectedMenu('billing')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="bx bx-receipt"></i>
              <span>Billing</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'billing' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('BILLING STATION')" :class="{ 'mm-active': selectedSub === 'billing-station' }">
                <a href="javascript: void(0);" @click="gotTo('billing-station')">Billing Station</a>
              </li>
            </ul>
          </li>

          <li v-if="getRight('PAYMENT AND RECEIPTING')" :class="{ 'mm-active': selected === 'Payments & Receipting' }">
            <a @click="selectedMenu('Payments & Receipting')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="mdi mdi-receipt"></i>
              <span>Payments</span>
            </a>
            <ul aria-expanded="false" class="sub-menu" :class="{ 'mm-active': selected === 'Payments & Receipting' }">
              <li v-if="getRight('BULK RECEIPTS')" :class="{ 'mm-active': selectedSub === 'bulk-receipts' }">
                <a style="cursor: pointer;" @click="gotTo('bulk-receipts')">Receive Payments</a>
              </li>
              <li v-if="getRight('VIEW RECEIPTS')" :class="{ 'mm-active': selectedSub === 'receipts' }">
                <a style="cursor: pointer;" @click="gotTo('receipts')">View Receipts</a>
              </li>
            </ul>
          </li>


          <!-- Insurance Claims -->
          <li v-if="getRight('INSURANCE CLAIMS')">
            <a @click="gotTo('insurance-claims')">
              <i class="bx bx-shield"></i>
              <span>Insurance Claims</span>
            </a>
          </li>

          <!-- Laboratory -->
          <li v-if="getRight('LABORATORY')" :class="{ 'mm-active': selected === 'laboratory' }">
            <a @click="selectedMenu('laboratory')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="bx bx-test-tube"></i>
              <span>Laboratory</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'laboratory' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('LAB DASHBOARD')" :class="{ 'mm-active': selectedSub === 'lab-dashboard' }">
                <a href="javascript: void(0);" @click="gotTo('lab-dashboard')">Lab Dashboard</a>
              </li>
            </ul>
          </li>

          <!-- Radiology -->
          <li v-if="getRight('RADIOLOGY')" :class="{ 'mm-active': selected === 'radiology' }">
            <a @click="selectedMenu('radiology')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="bx bx-scan"></i>
              <span>Radiology</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'radiology' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('RADIOLOGY DASHBOARD')" :class="{ 'mm-active': selectedSub === 'radiology-dashboard' }">
                <a href="javascript: void(0);" @click="gotTo('radiology-dashboard')">Radiology Dashboard</a>
              </li>
            </ul>
          </li>

          <!-- Theatre -->
          <li v-if="getRight('THEATRE')" :class="{ 'mm-active': selected === 'theatre' }">
            <a @click="selectedMenu('theatre')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="bx bx-plus-medical"></i>
              <span>Theatre</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'theatre' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('THEATRE DASHBOARD')" :class="{ 'mm-active': selectedSub === 'theatre-dashboard' }">
                <a href="javascript: void(0);" @click="gotTo('theatre-dashboard')">Theatre Dashboard</a>
              </li>
            </ul>
          </li>


          <!-- TB & HIV Registry -->
          <li v-if="getRight('TB HIV REGISTRY')" :class="{ 'mm-active': selected === 'tb-hiv' }">
            <a @click="selectedMenu('tb-hiv')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="bx bx-plus-medical"></i>
              <span>TB & HIV Registry</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'tb-hiv' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('TB REGISTRY')" :class="{ 'mm-active': selectedSub === 'tb-dashboard' }">
                <a href="javascript: void(0);" @click="gotTo('tb-dashboard')">TB Registry</a>
              </li>
              <li v-if="getRight('HIV REGISTRY')" :class="{ 'mm-active': selectedSub === 'hiv-dashboard' }">
                <a href="javascript: void(0);" @click="gotTo('hiv-dashboard')">HIV Registry</a>
              </li>
            </ul>
          </li>

          <!-- Pharmacy -->
          <li v-if="getRight('PHARMACY')" :class="{ 'mm-active': selected === 'pharmacy' }">
            <a @click="selectedMenu('pharmacy')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="bx bx-capsule"></i>
              <span>Pharmacy</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'pharmacy' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('PHARMACY DASHBOARD')" :class="{ 'mm-active': selectedSub === 'pharmacy-dashboard' }">
                <a href="javascript: void(0);" @click="gotTo('pharmacy-dashboard')">Pharmacy Dashboard</a>
              </li>
              <li class="menu-divider"></li>
              <li v-if="getRight('PHARMACY INVENTORY')" :class="{ 'mm-active': selectedSub === 'pharmacy-inventory' }">
                <a href="javascript: void(0);" @click="gotTo('pharmacy-inventory')">Inventory</a>
              </li>
              <li v-if="getRight('DRUG CATALOG')" :class="{ 'mm-active': selectedSub === 'drug-catalog' }">
                <a href="javascript: void(0);" @click="gotTo('drug-catalog')">Drug Catalog</a>
              </li>
              <li v-if="getRight('STOCK RECEIVE')" :class="{ 'mm-active': selectedSub === 'stock-receive' }">
                <a href="javascript: void(0);" @click="gotTo('stock-receive')">Receive Stock</a>
              </li>
              <li v-if="getRight('STOCK MOVEMENTS')" :class="{ 'mm-active': selectedSub === 'stock-movements' }">
                <a href="javascript: void(0);" @click="gotTo('stock-movements')">Stock Movements</a>
              </li>
            </ul>
          </li>

          <!-- Inpatient (IPD) -->
          <li v-if="getRight('IPD')" :class="{ 'mm-active': selected === 'ipd' }">
            <a @click="selectedMenu('ipd')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="bx bx-bed"></i>
              <span>Inpatient (IPD)</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'ipd' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('IPD DASHBOARD')" :class="{ 'mm-active': selectedSub === 'ipd-dashboard' }">
                <a href="javascript: void(0);" @click="gotTo('ipd-dashboard')">IPD Dashboard</a>
              </li>
              <li class="menu-divider"></li>
              <li v-if="getRight('ADMIT PATIENT')" :class="{ 'mm-active': selectedSub === 'admit-patient' }">
                <a href="javascript: void(0);" @click="gotTo('admit-patient')">Admit Patient</a>
              </li>
              <li v-if="getRight('WARD MANAGEMENT')" :class="{ 'mm-active': selectedSub === 'ward-management' }">
                <a href="javascript: void(0);" @click="gotTo('ward-management')">Ward Management</a>
              </li>
            </ul>
          </li>

          <!-- Procedures -->
          <li v-if="getRight('PROCEDURES')" :class="{ 'mm-active': selected === 'procedures' }">
            <a @click="selectedMenu('procedures')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="bx bx-cut"></i>
              <span>Procedures</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'procedures' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('SCHEDULE PROCEDURE')" :class="{ 'mm-active': selectedSub === 'schedule-procedure' }">
                <a href="javascript: void(0);" @click="gotTo('schedule-procedure')">Schedule Procedure</a>
              </li>
              <li v-if="getRight('SCHEDULED PROCEDURES')" :class="{ 'mm-active': selectedSub === 'scheduled-procedures' }">
                <a href="javascript: void(0);" @click="gotTo('scheduled-procedures')">Scheduled</a>
              </li>
              <li v-if="getRight('PROCEDURE HISTORY')" :class="{ 'mm-active': selectedSub === 'procedure-history' }">
                <a href="javascript: void(0);" @click="gotTo('procedure-history')">Completed</a>
              </li>
              <li v-if="getRight('THEATRE SCHEDULE')" :class="{ 'mm-active': selectedSub === 'theatre-schedule' }">
                <a href="javascript: void(0);" @click="gotTo('theatre-schedule')">Theatre Schedule</a>
              </li>
            </ul>
          </li>

          <!-- Referrals -->
          <li v-if="getRight('REFERRALS')" :class="{ 'mm-active': selected === 'referrals' }">
            <a @click="selectedMenu('referrals')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="bx bx-transfer"></i>
              <span>Referrals</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'referrals' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('NEW REFERRAL')" :class="{ 'mm-active': selectedSub === 'new-referral' }">
                <a href="javascript: void(0);" @click="gotTo('new-referral')">Create Referral</a>
              </li>
              <li v-if="getRight('OUTGOING REFERRALS')" :class="{ 'mm-active': selectedSub === 'outgoing-referrals' }">
                <a href="javascript: void(0);" @click="gotTo('outgoing-referrals')">Outgoing Referrals</a>
              </li>
              <li v-if="getRight('INCOMING REFERRALS')" :class="{ 'mm-active': selectedSub === 'incoming-referrals' }">
                <a href="javascript: void(0);" @click="gotTo('incoming-referrals')">Incoming Referrals</a>
              </li>
              <li v-if="getRight('REFERRAL HISTORY')" :class="{ 'mm-active': selectedSub === 'referral-history' }">
                <a href="javascript: void(0);" @click="gotTo('referral-history')">All Referrals</a>
              </li>
            </ul>
          </li>

          <!-- Morgue Management -->
          <li v-if="getRight('MORGUE')" :class="{ 'mm-active': selected === 'morgue' }">
            <a @click="selectedMenu('morgue')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="bx bx-building"></i>
              <span>Morgue</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'morgue' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('MORGUE DASHBOARD')" :class="{ 'mm-active': selectedSub === 'morgue-dashboard' }">
                <a href="javascript: void(0);" @click="gotTo('morgue-dashboard')">Morgue Dashboard</a>
              </li>
            </ul>
          </li>

          <!-- Hospital Reports -->
          <li v-if="getRight('HOSPITAL REPORTS')" :class="{ 'mm-active': selected === 'hospital-reports' }">
            <a @click="selectedMenu('hospital-reports')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="bx bx-line-chart"></i>
              <span>Hospital Reports</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'hospital-reports' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('DAILY REPORTS')" :class="{ 'mm-active': selectedSub === 'daily-reports' }">
                <a href="javascript: void(0);" @click="gotTo('daily-reports')">Daily Summary</a>
              </li>
              <li v-if="getRight('OPD REPORTS')" :class="{ 'mm-active': selectedSub === 'opd-reports' }">
                <a href="javascript: void(0);" @click="gotTo('opd-reports')">OPD Reports</a>
              </li>
              <li v-if="getRight('IPD REPORTS')" :class="{ 'mm-active': selectedSub === 'ipd-reports' }">
                <a href="javascript: void(0);" @click="gotTo('ipd-reports')">IPD Reports</a>
              </li>
              <li v-if="getRight('LAB REPORTS')" :class="{ 'mm-active': selectedSub === 'lab-reports' }">
                <a href="javascript: void(0);" @click="gotTo('lab-reports')">Laboratory Reports</a>
              </li>
              <li v-if="getRight('PHARMACY REPORTS')" :class="{ 'mm-active': selectedSub === 'pharmacy-reports' }">
                <a href="javascript: void(0);" @click="gotTo('pharmacy-reports')">Pharmacy Reports</a>
              </li>
              <li v-if="getRight('MORBIDITY REPORTS')" :class="{ 'mm-active': selectedSub === 'morbidity-reports' }">
                <a href="javascript: void(0);" @click="gotTo('morbidity-reports')">Morbidity Reports</a>
              </li>
              <li v-if="getRight('MOH REPORTS')" :class="{ 'mm-active': selectedSub === 'moh-reports' }">
                <a href="javascript: void(0);" @click="gotTo('moh-reports')">MOH Returns</a>
              </li>
            </ul>
          </li>

          <!-- Hospital Settings -->
          <li v-if="getRight('HOSPITAL SETTINGS')" :class="{ 'mm-active': selected === 'hospital-settings' }">
            <a @click="selectedMenu('hospital-settings')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="bx bx-wrench"></i>
              <span>Hospital Settings</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'hospital-settings' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('FACILITY SETUP')" :class="{ 'mm-active': selectedSub === 'facilities' }">
                <a href="javascript: void(0);" @click="gotTo('facilities')">
                  <i class="bx bx-hospital me-1"></i>Facilities
                </a>
              </li>
              <li v-if="getRight('DEPARTMENT SETUP')" :class="{ 'mm-active': selectedSub === 'department-setup' }">
                <a href="javascript: void(0);" @click="gotTo('department-setup')">Departments</a>
              </li>
              <li v-if="getRight('WARD SETUP')" :class="{ 'mm-active': selectedSub === 'ward-setup' }">
                <a href="javascript: void(0);" @click="gotTo('ward-setup')">Wards & Beds</a>
              </li>
              <li v-if="getRight('STAFF SETUP')" :class="{ 'mm-active': selectedSub === 'staff-setup' }">
                <a href="javascript: void(0);" @click="gotTo('staff-setup')">Staff Management</a>
              </li>
              <li class="menu-divider"></li>
              <li v-if="getRight('SERVICE CHARGES')" :class="{ 'mm-active': selectedSub === 'service-charges-setup' }">
                <a href="javascript: void(0);" @click="gotTo('service-charges-setup')">Service Charges</a>
              </li>
              <li v-if="getRight('DRUG MASTER')" :class="{ 'mm-active': selectedSub === 'drug-master' }">
                <a href="javascript: void(0);" @click="gotTo('drug-master')">Drug Master List</a>
              </li>
              <li v-if="getRight('LAB TESTS SETUP')" :class="{ 'mm-active': selectedSub === 'lab-tests-setup' }">
                <a href="javascript: void(0);" @click="gotTo('lab-tests-setup')">Lab Tests Catalog</a>
              </li>
              <li v-if="getRight('PROCEDURE TYPES')" :class="{ 'mm-active': selectedSub === 'procedure-types-setup' }">
                <a href="javascript: void(0);" @click="gotTo('procedure-types-setup')">Procedure Types</a>
              </li>
              <li v-if="getRight('ICD10 CODES')" :class="{ 'mm-active': selectedSub === 'icd10-codes' }">
                <a href="javascript: void(0);" @click="gotTo('icd10-codes')">ICD-10 Codes</a>
              </li>
            </ul>
          </li>

        </ul>
      </div>
      <!-- Sidebar -->
    </div>
  </div>

</template>

<script>
/* eslint-disable */
import {MetisMenu} from 'metismenujs';
import {authUrl, biller, county_logo, execute, getRight, hospital} from "@/api";

export default {
  name: 'NavigationBar',

  data() {
    return {
      county: {
        id: null,
        countyID: null,
        countyName: null,
        tagline: null,
        smsusername: null,
        smspassword: null,
        contact: null,
        center: null,
        address: null,
        email: null,
        headline: null,
        tagline2: null,
        ussd: null,
        logo: null,
        bank: null,
        powered: null,
        stateLogo: null,
        QRLink: null
      },
      sessionNames: '',
      sessionFacility: '',
      sessionFacilityID: '',
      facilities: [],
      isVerticalMenuHidden: false,
      permission: "",
      category: "",
      newBill: true,
      dashboard: true,
      paymentsReceipting: true,
      financeAct: true,
      tenantAreas: true,
      bills: true,
      trade: true,
      parking: true,
      reports: true,
      settings: true,
      zones: true,
      users: true,
      liveMonitoring: true,
      transactions: true,
      businessMapping: true,

      selectedSub: null,
      selected: null,
      helmet: {
        names: ''
      },
    };
  },
  components: {},

  methods: {

    county_logo() {
      return county_logo
    },

    getRight(type) {
      return getRight(type)
    },

    selectedMenu(selected) {
      sessionStorage.setItem("selected", selected)
      this.selected = selected
    },

    gotToSelected(selected) {
      sessionStorage.setItem("currentPage", selected)
      sessionStorage.setItem("selected", selected)
      this.selected = selected
      this.$router.push('/' + selected);
    },

    gotTo(route) {
      sessionStorage.setItem("selectedSub", route)
      sessionStorage.setItem("currentPage", route)
      this.selectedSub = route
      this.$router.push('/' + route);
    },

    changePassword() {
      let route = sessionStorage.getItem("changePass")
      sessionStorage.setItem("selectedSub", route)
      sessionStorage.setItem("currentPage", route)
      this.$router.push('/' + route);
    },

    // Hospital facility selector - NO RELOAD
    selectFacility(facility) {
      sessionStorage.setItem("hospitalFacilityID", facility.facilityID)
      sessionStorage.setItem("hospitalFacilityName", facility.facilityName)
      this.sessionFacility = facility.facilityName
      this.sessionFacilityID = facility.facilityID
      // Navigate to hospital dashboard after selection
      this.gotTo('hospital-dashboard')
    },


    getCounty() {
      const data = new FormData();
      data.append("function", "getCounty");
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.county = res.data.data.county
            } else {
              // alert(res.data.message)
            }
          })
          .catch((e) => {
            //alert(e.message);
            this.message = e.message
          });
    },

    logout(route) {
      const data = new FormData();
      data.append("function", "logout");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, authUrl)
          .then((res) => {
            sessionStorage.clear()
            this.$router.push(route);

            if (res.data.success) {

            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            //alert(e.message);
            this.message = e.message
          });
    }
  },

  mounted() {
    this.getCounty()


    this.sessionNames = sessionStorage.getItem("sessionNames")
    this.sessionFacility = sessionStorage.getItem("hospitalFacilityName") || ''
    this.sessionFacilityID = sessionStorage.getItem("hospitalFacilityID") || ''

    this.names = sessionStorage.getItem("names")
    new MetisMenu('#side-menu');
    this.selected = sessionStorage.getItem("selected")
    this.selectedSub = sessionStorage.getItem("selectedSub")
    this.category = sessionStorage.getItem("category")
    this.permission = sessionStorage.getItem("permission")


    if (this.category === "EXECUTIVE") {
      this.newBill = false
      this.dashboard = true
      this.paymentsReceipting = false
      this.financeAct = false
      this.tenantAreas = false
      this.bills = false
      this.trade = false
      this.parking = false
      this.reports = true
      this.settings = false
      this.zones = false
      this.users = false
      this.liveMonitoring = false
      this.transactions = false
      this.businessMapping = false

    } else if (this.category === "CASHIER") {

      this.newBill = true
      this.dashboard = false
      this.paymentsReceipting = true
      this.financeAct = false
      this.tenantAreas = true
      this.bills = true
      this.trade = true
      this.parking = true
      this.reports = false
      this.settings = false
      this.zones = false
      this.users = false
      this.liveMonitoring = false
      this.transactions = true
      this.businessMapping = false
    } else {
      this.newBill = true
      this.dashboard = true
      this.paymentsReceipting = true
      this.financeAct = true
      this.tenantAreas = true
      this.bills = true
      this.trade = true
      this.parking = true
      this.reports = true
      this.settings = true
      this.zones = true
      this.users = true
      this.liveMonitoring = true
      this.transactions = true
      this.businessMapping = true
    }
  }
};

</script>
<style>


.page-topbar {
  transition: margin-left 0.3s ease;
}

.page-topbar-minimize {
  margin-left: 80px;
}

.hide-vertical-menu {
  display: none;
}

.content-minimize {
  transition: margin-left 0.3s ease;
  margin-left: 80px;
}

.menu-divider {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin: 5px 15px;
}

@media (max-width: 768px) {
  #vertical-menu {
    display: none;
  }

  .hide-vertical-menu #vertical-menu {
    display: block;
  }

  #vertical-menu.show-mobile-verticle {
    display: block !important;
  }
}


@media print {
  .footer,
  .navbar-header,
  .page-title-box,
  .right-bar,
  .vertical-menu {
    display: none !important
  }

  .card-body,
  .content-minimize,
  .page-content,
  .right-bar,
  body {
    padding: 0;
    margin: 0
  }

  .card {
    border: 0
  }
}

.content-minimize {
  margin-left: 250px;
  overflow: hidden
}

.content-minimize .content {
  padding: 0 15px 10px 15px;
  margin-top: 70px
}

@media (max-width: 992px) {
  .vertical-menu {
    display: none
  }

  .content-minimize {
    margin-left: 0 !important
  }

  body.sidebar-enable .vertical-menu {
    display: block
  }

  #vertical-menu.show-mobile-verticle {
    display: block !important;
  }
}

.vertical-collpsed .content-minimize {
  margin-left: 70px
}

body[data-layout=horizontal] .content-minimize {
  margin-left: 0 !important
}


body[data-sidebar-size=small] .content-minimize {
  margin-left: 160px
}

body[data-sidebar-size=small].vertical-collpsed .content-minimize {
  margin-left: 70px
}


</style>